import { render, staticRenderFns } from "./ReceiptNotePreview.vue?vue&type=template&id=c9898384&scoped=true"
import script from "./ReceiptNotePreview.vue?vue&type=script&lang=ts"
export * from "./ReceiptNotePreview.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptNotePreview.vue?vue&type=style&index=0&id=c9898384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9898384",
  null
  
)

export default component.exports